import { useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getCrmAlerts,
  getCrmInsights,
  getCrmIntake,
  getCrmMyDay,
  getCrmPipeline,
} from '../../api';
import { crmKeys } from './crmQueryKeys';

export function useCrmPipeline(params: {
  mineOnly?: boolean;
  managerId?: number | null;
  includeUnassigned?: boolean;
  crmDepartment?: string | null;
  enabled?: boolean;
}) {
  const { mineOnly, managerId, includeUnassigned = true, crmDepartment, enabled = true } = params;
  return useQuery({
    queryKey: crmKeys.pipeline({ mineOnly, managerId, includeUnassigned, crmDepartment }),
    queryFn: () =>
      getCrmPipeline({
        mine_only: mineOnly,
        manager_id: managerId ?? undefined,
        include_unassigned: includeUnassigned,
        crm_department: crmDepartment ?? undefined,
      }),
    enabled,
  });
}

export function useCrmMyDay(managerId?: number | null, enabled = true) {
  return useQuery({
    queryKey: crmKeys.myDay(managerId),
    queryFn: () => getCrmMyDay({ manager_id: managerId ?? undefined }),
    enabled,
  });
}

export function useCrmIntake(managerId?: number | null, enabled = true) {
  return useQuery({
    queryKey: crmKeys.intake({ managerId }),
    queryFn: () => getCrmIntake({ manager_id: managerId ?? undefined }),
    enabled,
  });
}

export function useCrmAlerts(managerId?: number | null, enabled = true) {
  return useQuery({
    queryKey: crmKeys.alerts({ managerId }),
    queryFn: () => getCrmAlerts({ manager_id: managerId ?? undefined }),
    enabled,
  });
}

export function useCrmInsights(days: number, managerId?: number | null, enabled = true) {
  return useQuery({
    queryKey: crmKeys.insights({ days, managerId }),
    queryFn: () => getCrmInsights({ days, manager_id: managerId ?? undefined }),
    enabled,
  });
}

export function useInvalidateCrm() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: crmKeys.all });
}

